import React, { createContext, useState, useContext } from "react";

const SnackBarContext = createContext();

export const SnackBarProvider = ({ children }) => {
    const [snack, setSnack] = useState({
        message: "",
        isVisible: false,
        className: "",
    });

    const showSnackBar = (message, className = "") => {
        setSnack({ message, isVisible: true, className });
        setTimeout(() => { setSnack((prev) => ({ ...prev, isVisible: false })) }, 3000);
    };

    return (
        <SnackBarContext.Provider value={{ snack, showSnackBar }}>
            {children}
        </SnackBarContext.Provider>
    );
};

export const useSnackBar = () => useContext(SnackBarContext);



